import { LedgerAccountName } from "@/graphql/index";

const buildLedgerAccountKey = (
  domain: string,
  id: number | string = "",
  name: number | string,
) => `${domain}:${id}:${name}`;

const AccountDomain = {
  User: "user",
  Workspace: "workspace",
  WorkspaceGroup: "workspace_group",
  WorkspaceGroupMember: "workspace_group_member",
  WorkspaceMember: "workspace_member",
  Program: "program",
};

const AccountNames = {
  Available: LedgerAccountName.Available.toLowerCase(),
  Receivable: LedgerAccountName.Receivable.toLowerCase(),
};

export class LedgerAccountKeyUtils {
  static UserAvailable(userId = "") {
    return buildLedgerAccountKey(
      AccountDomain.User,
      userId,
      AccountNames.Available,
    );
  }

  static UserReceivable(userId = "") {
    return buildLedgerAccountKey(
      AccountDomain.User,
      userId,
      AccountNames.Receivable,
    );
  }

  static WorkspaceAvailable(workspaceId = "") {
    return buildLedgerAccountKey(
      AccountDomain.Workspace,
      workspaceId,
      AccountNames.Available,
    );
  }

  static WorkspaceGroupAvailable(groupId: string | number) {
    return buildLedgerAccountKey(
      AccountDomain.WorkspaceGroup,
      groupId,
      AccountNames.Available,
    );
  }

  static WorkspaceGroupMemberAvailable(memberId: string | number) {
    return buildLedgerAccountKey(
      AccountDomain.WorkspaceGroupMember,
      memberId,
      AccountNames.Available,
    );
  }

  static WorkspaceMemberAvailable(memberId: string | number) {
    return buildLedgerAccountKey(
      AccountDomain.WorkspaceMember,
      memberId,
      AccountNames.Available,
    );
  }

  static ProgramAvailable(programId = "") {
    return buildLedgerAccountKey(
      AccountDomain.Program,
      programId,
      AccountNames.Available,
    );
  }
}
